import { css } from '@emotion/react';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const footer = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 16px 0;
  margin: 0 20px 0;

  ${MEDIA_MIN_SM} {
    padding: 16px 20px;
    margin: 0 auto 0;
  }
`;
